import React, { useEffect, useState, useCallback } from 'react';
import { makeStyles, Button } from '@material-ui/core';
import { injectIntl } from 'react-intl';
import * as API from 'services/api';
import { useDispatch } from 'react-redux';
import { setLoading } from 'redux/actions/app';
import moment from 'moment'
import { get10LastLetters } from 'utils/validations'
import { CustomTable } from 'components'
import VisibilityIcon from '@material-ui/icons/Visibility';
import OrderDetails from './detail';
import { LEAD_EXTERNAL_STATUSES } from 'config';
import EmptyPage from 'components/EmptyPage';
import PropTypes from 'prop-types';
import { tableOptions } from 'pages/common';

const useStyles = makeStyles(theme => ({
  table: {
    backgroundColor: 'white'
  },
  cartBtn: {
    borderRadius: 4,
    color: "#05A969"
  },
}));

const Orders = ({
  intl: { formatMessage },
  reduced
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [orders, setOrders] = useState([])
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (!reduced)
      dispatch(setLoading(true));
    API.getMyOrders({})
      .then(res => {
        dispatch(setLoading(false));
        if (res.data && res.data.length > 0) {
          const newData = res.data.map(item => ({
            ...item.source,
            ...item,
            id: item.id
          }));
          setOrders(reduced ? newData.slice(0, 5) : newData)
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  }, []);
  const tableColumns = [
    {
      name: 'id',
      label: "ID commande",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => get10LastLetters(value)
      }
    },
    {
      name: 'createdAt',
      label: "Date",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/YYYY")
      }
    },
    {
      name: 'source.title',
      label: "Libellé du produit",
      options: {
        display: true,
        sort: true
      }
    },
    {
      name: 'source.quantity',
      label: "Quantité",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => (value || 1) + " produit(s)"
      }
    },
    {
      name: 'price',
      label: "Montant HT",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => value + '€'
      }
    },
    {
      name: 'statusExternal',
      label: "Statut",
      options: {
        display: true,
        sort: true,
        customBodyRender: (value) => formatMessage({
          id: 'action.status.' + (!LEAD_EXTERNAL_STATUSES.includes(value) ? LEAD_EXTERNAL_STATUSES[0] : value),
        }),
      }
    },
    {
      name: 'actions',
      label: "",
      options: {
        display: true,
        sort: false,
        customBodyRender: useCallback((value, tableMeta) => <Button
          className={classes.cartBtn}
          style={{ textTransform: 'none' }}
          startIcon={<VisibilityIcon />}
          onClick={() => {
            const id = tableMeta.rowData[0];
            const order = orders.find(item => item.id == id)
            setOpenModal(order)
          }}
        >
          {'Détails'}
        </Button>, [orders])
      }
    }
  ];

  return (
    <div>
      {
        orders.length > 0 ?
          <CustomTable
            columns={tableColumns}
            data={orders}
            options={{
              ...tableOptions(),
            }}
          /> :
          <EmptyPage title="Vous n’avez réalisé aucune commande." reduced={reduced} />
      }
      {
        openModal &&
        <OrderDetails
          open={openModal}
          handleClose={(data) => { setOpenModal(data) }}
        />
      }
    </div>
  );
};
Orders.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }),
  reduced: PropTypes.bool
};
export default injectIntl(Orders);
